/**
 * Client entry: mount the App over the boot wordmark in #app.
 */
import { render } from 'preact';
// ⛔ T1749 M2 — THE STYLESHEET ORDER IS THE CASCADE AND IT IS LOAD-BEARING.
// Five sheets, in exactly this order, on BOTH tools:
//   1. @ecmb/ui/styles/tokens.css  the 43 shared names (DESIGN.md §3), declared once
//   2. ./styles/tokens.css         this surface's exceptions only (never a shared name)
//   3. @ecmb/ui/styles/base.css    ADR4-D3's one base layer; consumes the tokens
//   4. @ecmb/ui/styles/components.css  the rules both tools share, byte for byte
//   5. ./styles/app.css            this surface's own rules; overrides everything above
// A component rule moved into (4) therefore has LOWER precedence than anything left in
// (5), which is why M2's move was restricted to rules no later app.css rule overrides.
// `style-contract.spec.ts` asserts this exact list, on both tools.
import '@ecmb/ui/styles/tokens.css';
import './styles/tokens.css';
import '@ecmb/ui/styles/base.css';
import '@ecmb/ui/styles/components.css';
import './styles/app.css';
import { App } from './App.js';
import { createStore } from './store/store.js';
import { purgeLegacyNursingCaptures } from './lib/purgeLegacyNursingCaptures.js';
import { startPushOnLaunch } from './lib/push-register.js';

// ⛔ BEFORE THE MOUNT, AND UNCONDITIONALLY — not inside the `if (root)` below.
// This erases personal data M7 orphaned (see the module header); whether the
// app has somewhere to render is irrelevant to whether that data should still
// exist, and it must not depend on a screen being reached.
purgeLegacyNursingCaptures();

// T1141 M5 — register the service worker and, IF the permission is already
// granted, re-subscribe this device and re-POST it.
//
// ⛔ ON EVERY LAUNCH, WHICH IS THE ONLY REPAIR MECHANISM AVAILABLE: iOS supports
// `pushsubscriptionchange` nowhere, so there is no event to tell us the OS has
// rotated or dropped this device's subscription. The server upserts on
// `endpoint`, so the normal case writes no new row.
// ⛔ IT NEVER PROMPTS — the permission dialog is raised only from the operator
// screen's own tap. See the function's header for why the failure is silent and
// what reads it.
// `void`, not awaited: nothing about the mount depends on it, and blocking the
// first paint of a counter kiosk on a network round trip would be a real
// regression for a feature that is allowed to be late.
void startPushOnLaunch();

const root = document.getElementById('app');
if (root) {
  // Preact keeps non-matching pre-existing children on first mount — the
  // static boot wordmark must go, or it stacks above the app and pushes the
  // rail's bottom anchor below the 768px fold (M2 ux-review BLOCK).
  root.replaceChildren();
  render(<App store={createStore()} />, root);
}
